const font = {
  mono: "'GT Mono', monospace",
  primary: "'GT', sans-serif",
  secondary: "'GT', sans-serif",
  fontLg: '16px',
  fontMd: '14px',
  fontSm: '12px',
};

const GUTTER = 24;

const size = {
  width: '1300px',
  cardMaxWidth: 900,
  authWidth: 440 + GUTTER * 2,
};

const color = {
  black: '#181818',
  blue: '#2171D1',
  dark: '#3C4043',
  darkGrey: '#767676',
  green: '#27865F',
  grey: '#626262',
  greyLight: '#EBEBEB',
  red: '#A51930',
  white: 'white',

  // hover
  blackHover: '#343332',
  blueHover: '#125EBA',
  greenHover: '#09774A',
  orangeHover: '#E68F12',
  purpleHover: '#714DCE',
  redHover: '#B81F0F',
};

const colors = {
  btnSecondary: '#D2D6D9',
  btnTertiary: '#6B6B6B',
  invalid: '#D11F3D',
  invalidBg: '#FCE7E6',
  valid: '#02875B',
  validBg: '#E6F3EF',
  bg: '#f8f8f8',
  primary: '#181818',
  fontSecondary: '#3C4043',
  fontTertiary: '#767676',
  primaryHover: '#f3f3f3',
  enigmaBlue: '#2171D1',
  enigmaGreen: '#27865F',
  enigmaRed: '#A51930',
  enigmaBlack: '#111111',
  enigmaDark: '#3C4043',
  enigmaGrey: '#626262',
  enigmaDarkGrey: '#767676',
  enigmaGreyLight: '#EBEBEB',
  enigmaWhite: 'white',
  matchScore: {
    high: { bg: 'rgb(228,248,242)', color: '#015136' },
    medium: { bg: 'rgb(255,236,209)', color: '#ff9600' },
    low: { bg: 'rgb(246,210,216)', color: '#b1364a' },
  },
};

const borders = {
  borderLt: '1px solid #EBEBEB',
  borderMd: '1px solid #D2D6D9',
};

const box = {
  gutterNumber: GUTTER,
  gutter: `${GUTTER}px`,
  inputBorderRadius: '8px',
  cardBorderRadius: '8px',
  formRhythm: `margin-bottom: 16px`,
};

// devices
const device = {
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)',
};

const effects = {
  defaultShadow: '0px 8px 28px rgba(0, 0, 0, 0.05)',

  transition: (arg = 'all', time = '400ms', delay = '0ms') => {
    return `transition: ${arg} ${time} ease ${delay}`;
  },
  shadow: (opacity = 0.09, brightness = 0, spread = 10) => {
    // drop shadow
    return `box-shadow: 0 0px ${spread}px 0 rgba(${brightness}, ${brightness}, ${brightness}, ${opacity});`;
  },
  ellipsis: {
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap',
  },
};

const theme = {
  ...size,
  ...colors,
  ...borders,
  ...effects,
  ...box,
  color,
  font,
  device,
};

export default theme;
